import React, { useState } from 'react'

import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

const Search = (props) => {
    const {
        id,
        name,
        label,
        options,
        placeholder,
        getOptionLabel,
        defaultValue,
        multiple,
        value,
        disabled,
        handleOnChangeSearch,
        handleOnSelectSearchItem,
        isOptionEqualToValue,
        onClose,
        loading
    } = props

    const [searchInputText, setSearchInputText] = useState('')

    return (
        <Autocomplete
            id={id}
            name={name}
            options={options}
            loading={loading}
            value={value}
            getOptionLabel={getOptionLabel}
            defaultValue={defaultValue}
            multiple={multiple}
            disabled={disabled}
            isOptionEqualToValue={isOptionEqualToValue}
            fullWidth
            inputValue={searchInputText}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                />
            )}
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={(event, newValue) => {
                handleOnSelectSearchItem(newValue)
            }}
            onClose={onClose}
            onInputChange={(event, newInputValue) => {
                setSearchInputText(newInputValue)
                handleOnChangeSearch(newInputValue)
            }}
        />
    )
}

export default Search
